import { TranslationContextType } from '../../../context/TranslationProvider';
import { z } from 'zod';

export const formSchema = (t: TranslationContextType['t']) =>
  z.object({
    email: z
      .string({
        required_error: t('common.newsletter.error.required'),
        invalid_type_error: t('common.newsletter.error.required'),
      })
      .nonempty({ message: t('common.newsletter.error.required') })
      .email({ message: t('common.newsletter.error.invalid') }),
  });
